import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "filter-pill-avatar" }

import FilterIcon from './FilterIcon.vue';
import UserAvatar from '@/components/widgets/UserAvatar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PillAvatars',
  props: {
    type: {},
    noAssignee: { type: Boolean },
    firstThreeValues: {},
    groupAvatarId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.noAssignee)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["no-assignee-icon", { '-mr-[7px]': _ctx.firstThreeValues.length }])
        }, [
          _createVNode(FilterIcon, {
            icon: 'avatar',
            "icon-name": 'avatar',
            type: _ctx.type
          }, null, 8, ["type"])
        ], 2))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstThreeValues, (avatar) => {
      return (_openBlock(), _createBlock(UserAvatar, {
        key: avatar,
        member: { id: avatar },
        "group-avatar-id": _ctx.groupAvatarId,
        size: 'extra-small',
        class: "z-[1]"
      }, null, 8, ["member", "group-avatar-id"]))
    }), 128))
  ]))
}
}

})